const textProps = {
  color: "orange",
  icon: "fas fa-smile-beam",
  title: "Best Quality",
  description:
    "It becomes harder for us to give others a hand. We get our heart broken by people we love.",
  gradient: false,
};
export default textProps;
